module.exports = __webpack_public_path__ + "img/eco-negative-without-symptons.6fc1d572.png";